import { cva } from 'class-variance-authority';

export const containerVariants = cva(
  'text-xs mt-2 not-italic text-gray-700 md:text-xs min-h-max grid grid-cols-[max-content_auto] grid-rows-[auto_auto] items-center',
  {
    variants: {
      size: {
        small: '',
        large: '!text-base gap-x-1 grid grid-cols-[max-content_auto] grid-rows-[max-content_max-content]',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  }
);

export const iconVariants = cva('drop-shadow-md border rounded-full mr-2 row-span-full', {
  variants: {
    size: {
      small: 'w-6 h-6',
      large: 'w-10 h-10 row-[1/3]',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

export const dateVariants = cva('text-gray-500 min-w-max', {
  variants: {
    size: {
      small: '-mt-[2px]',
      large: 'text-sm',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});
